import * as React from 'react';
import { determinePreset } from '../../common/helpers/image';
import { useWindowResize } from '../../common/hooks/useWindowResize';
import { SuperLink } from '../super-link/SuperLink';
import { PressMaterialProps } from './PressMaterial.props';
import { StyledPressMaterial, StyledSubtitle, StyledTitle, StyledTitleContainer } from './PressMaterial.styles';

export const PressMaterial = (props: PressMaterialProps) => {
  const { title, subTitle, imageWithPresets, index, bottomPadding } = props;
  const { uiScreenType } = useWindowResize();
  const image: Image = determinePreset(imageWithPresets, uiScreenType);
  const row = (index % 2) + 1;
  const column = Math.floor(index / 2) + 1;
  return (
    <StyledPressMaterial row={row} column={column}>
      <img src={image.src} alt={image.alt} />
      <StyledTitleContainer bottomPadding={bottomPadding}>
        <StyledTitle>{title}</StyledTitle>
        <StyledSubtitle>
          {subTitle &&
            subTitle.map((st: { link: string; target: string; text: string }) => (
              <SuperLink to={st.link} target={st.target} key={st.text}>
                {st.text}
              </SuperLink>
            ))}
        </StyledSubtitle>
      </StyledTitleContainer>
    </StyledPressMaterial>
  );
};
